import { createStore } from "zustand/vanilla"
import { clickSelection } from "../lib/selection"

export type SelectionState = {
  selectedIds: string[]
  /** Objects a selection box is touching while it's dragged; outlined, not yet selected. */
  previewIds: string[]
  /** A click on an object: selects it alone, or toggles it when `additive` (Shift). */
  select: (id: string, additive?: boolean) => void
  setSelection: (ids: string[]) => void
  setPreview: (ids: string[]) => void
  clear: () => void
}

export const createSelectionStore = () => createStore<SelectionState>()((set, get) => ({
  selectedIds: [],
  previewIds: [],
  select: (id, additive = false) => set({
    selectedIds: clickSelection(get().selectedIds, id, additive),
  }),
  setSelection: (selectedIds) => set({ selectedIds }),
  setPreview: (previewIds) => {
    if (previewIds.join() !== get().previewIds.join()) set({ previewIds })
  },
  clear: () => set({ selectedIds: [] }),
}))

export type SelectionStore = ReturnType<typeof createSelectionStore>
